import { createSelector } from 'reselect';

export default createSelector(
  state => state.authConfig,
  authConfig => authConfig.keepSessionOpen,
);
